import Base from "./base"

export default class RoomByRouteSlugExists extends Base {
  constructor(Vue, store) {
    super("room-by-route-slug-exists", Vue, store)
  }

  async before(to, from, next) {
    const roomSlug = to.params.roomSlug

    if (_.isNull(roomSlug)) {
      next({name: "NotFound"})
      return
    }

    const room = this.store.getters["room/getBySlug"](roomSlug)

    if (_.isEmpty(room)) {
      next({name: "NotFound"})
      return
    }

    const isTalked = room.is_talked
    switch (to.name) {
      // シアタールームにアクセスしたが、取得したroomがトークルームだった場合
      case "TRoom":
        if (isTalked) {
          next({name: "NotFound"})
          return
        }

        break
      // トークルーム・トークルーム入室確認にアクセスしたが、取得したroomがシアタールームだった場合
      case "YRoom":
      case "YRoomEntry":
        if (!isTalked) {
          next({name: "NotFound"})
          return
        }

        break
    }

    next()
  }
}
